import script from "./SupportBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportBanner.vue?vue&type=script&setup=true&lang=js"

import "./SupportBanner.vue?vue&type=style&index=0&id=3a09761a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a09761a"]])

export default __exports__